import React, { useState } from "react";
import { adminAxios } from "../../axiosInstance";
import Date from "../../super_dashboard/components/Date";
import CancelIcon from "@mui/icons-material/Cancel";
import * as XLSX from "xlsx";

function ExportSalesList() {
  const [downloadModal, setDownloadModal] = useState(false);

  const [formData, setFormData] = useState({
    from: "",
    to: "",
  });

  const handleDateChange = (year, month, day, type) => {
    setFormData((prevData) => ({
      ...prevData,
      [type]: `${year}-${month}-${day}`,
    }));
  };

  const handleDownload = () => {
    setDownloadModal(true);
  };

  const handleSubmit = async () => {
    try {
      const response = await adminAxios.post("orders/download", formData);
      const filteredData = response?.data?.data?.map((item, index) => ({
        // "Image":,
        NO: index + 1,
        "ORDER NO": item?.orderNO,
        "CASHIER NAME": `${item?.user?.firstname} ${item?.user?.lastname}`,
        "CUSTOMER NAME": item?.customer?.name,
        "PAYMENT METHOD": item?.payment_type,
        "QUANTITY SOLD": item?.orderdetails[0]?.quantity_ordered,
        "TOTAL PRICE": item?.total_price,
        STATUS: item.status,
      }));

      const ws = XLSX.utils.json_to_sheet(filteredData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
      XLSX.writeFile(wb, "Sales.xlsx");
    } catch (err) {
      console.log("Error fetching data", err);
    } finally {
      setDownloadModal(false);
    }
  };
  return (
    <>
      <button
        onClick={() => handleDownload()}
        className="px-4 py-3 text-white rounded-lg bg-green-500"
      >
        Export Sales
      </button>

      {downloadModal && (
        <div className="fixed inset-0 flex justify-center items-start bg-black bg-opacity-50">
          <div className="bg-white rounded-lg p-4  my-12">
            <div className="flex justify-end">
              <CancelIcon
                onClick={() => setDownloadModal(false)}
                className="cursor-pointer text-black mb-2"
              />
            </div>
            <div className="flex flex-col gap-3 p-3">
              <div className="flex gap-4">
                <div className="flex flex-col w-full ">
                  <label htmlFor="Manufacturing Date">Start Date</label>
                  <Date
                    onDateChange={handleDateChange}
                    type={"from"}
                    className={"lg:w-full"}
                  />
                </div>
                <div className="flex flex-col w-full">
                  <label htmlFor="Expiring Date">End Date</label>
                  <Date
                    onDateChange={handleDateChange}
                    type={"to"}
                    className={"lg:w-full"}
                  />
                </div>
              </div>
              <div className="flex justify-center my-6 text-white font-medium text-xl p-3 bg-darkblue rounded-lg">
                <button
                  type="submit"
                  onClick={handleSubmit}
                  className="w-full h-full"
                  // disabled={loading}
                >
                  Download
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default ExportSalesList;
